<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import { required } from "vuelidate/lib/validators";
import ActivityAPI from "@/services/standards/trainingProgram/activityHealthAPI";
import Table from "@/components/standard/Induction/components/InductionTable";
import CompanyAPI from "@/services/company/companyAPI";
import CompanySSOAPI from "@/services/sso/company/companySSO.API";
import InductionAPI from "@/services/standards/inductionProgram/inductionProgramAPI";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";
import ItemAPI from "@/services/items/itemsAPI";

/**
 * Basic Tables component
 */
export default {
  page: {
    title: "1.2.2 Capacitación, Inducción y Reinducción en SG SST",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    Table,
  },
  data() {
    return {
      title: "1.2.2 Capacitación, Inducción y Reinducción en SG SST",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "1.2.2 Listado de Capacitación, Inducción y Reinducción en SG SST",
          href: `/forms/estandares/${this.$store.getters["company/getCompany"].id}/induccion`,
        },
        {
          text: " Ver Capacitación",
          active: true,
        },
      ],
      list: [],
      trainingList: [],

      program: {
        induction_date: null,
        induction_final_date: null,
        induction_theme: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
        observations: null,
        evidence: null,
      },

      submitted: false,

      company: null,

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,

      loading1: true,
      loading2: true,
      loading3: true,

      inductionID: this.$route.params.induction,

      item: null,
      itemStatus: null,

      itemData: null,
    };
  },
  validations: {
    program: {
      date: {
        required,
      },
      theme: {
        required,
      },
    },
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(10)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find((permission) => permission.name === name);

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    getFile(file) {
      const name = file.split("/");
      return name[name.length - 1];
    },

    getTrainingPrograms() {
      ActivityAPI.getTraining(this.companyID)
        .then((response) => {
          this.loading = false
          this.trainingList = response.programs;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false
        });
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 10)
        .then((response) => {
          this.item = response || null;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    getData() {
      CompanyAPI.getCompany(this.companyID)
        .then((response) => {
          CompanySSOAPI.getCompany(response.uuid)
            .then((r) => {
              this.company = r.nit;
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });

      InductionAPI.get(this.inductionID)
        .then((response) => {
          this.program.induction_date = response.induction_date,
            this.program.induction_final_date = response.induction_final_date,
            this.program.induction_theme = response.induction_theme,
            this.program.companies_id = response.companies_id,
            this.program.observations = response.observations,
            this.program.evidence = response.evidence,

            this.loading1 = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },
  },

  mounted() {
    this.getData();
    this.getItems();
    this.getItemData();
    this.getTrainingPrograms();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-lg-12">
        <div v-if="!loading1">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-12 text-right m-b-0">
                  <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="back" placement="left"> Volver </b-tooltip>
                </div>
              </div>

              <hr />

              <table
                class="pt-2 table table-sm table-responsive border-bottom max-w-full divide-y divide-gray-200 table-striped rounded col-sm-12">
                <thead class="table-active">
                  <tr>
                    <th scope="col" class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2">
                      Fecha inicio de capacitación
                    </th>

                    <th scope="col" class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2">
                      Fecha fin de Capacitación
                    </th>

                    <th scope="col" class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-3">
                      Nombre de la Capacitación
                    </th>
                    <th scope="col" class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-8">
                      Observaciones
                    </th>
                    <th scope="col" class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2">
                      Evidencia
                    </th>

                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                  <tr>
                    <td class="px-6 text-sm text-gray-500 mx-2">
                      {{ program.induction_date }}

                    </td>

                    <td class="px-6 text-sm text-gray-500 mx-2">
                      {{ program.induction_final_date }}

                    </td>

                    <td class="px-6 text-sm text-gray-500 mx-2">
                      <b>
                        Tema: <!-- {{ getThemeID(item.induction_theme) }} -->
                        {{ program.induction_theme }}
                      </b>
                    </td>
                    <td class="px-6 text-sm text-gray-500 mx-2">
                      {{ program.induction_date }}
                    </td>

                    <td class="px-6 text-sm text-gray-500 mx-2 align-middle text-center">
                      <button :disabled="!allowAccess()"
                        style=" background-color: transparent !important; border: none;" type="button"
                        @click="gotoDigitalOcean(`${program.evidence}`)"> <i class="mdi mdi-cloud-download"></i>
                      </button>
                      <b-tooltip :target="`evidence${program.evidence}`"> Descargar evidencia </b-tooltip>
                    </td>

                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- end card -->
        </div>

        <div v-else>
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
    <!--- end row -->
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
